// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__CcHmO"};